import AddTrainingWorkshop from 'src/pages/TrainingWorkshop/AddTrainingWorkshop';
import TrainingWorkshopList from 'src/pages/TrainingWorkshop/TrainingWorkshopList';

export const trainingWorkshopCreateRoutes = [
  { path: '/training-workshop', component: TrainingWorkshopList },  
  { path: '/training-workshop/add', component: AddTrainingWorkshop },  
];
